export class EmailContact {
  Name: string = null;
  Address: string = null;
}
